module.exports = __webpack_public_path__ + "img/forgot-password-v2.f2b81f6e.svg";